/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Represents the category of an investigation test type.
 */
export enum InvestigationTestTypeCategory {
    OTHER = 'other',
    A1 = 'a1',
    A2 = 'a2',
    A3 = 'a3',
}
